import React from 'react'
import ContactForm from '../ContactFrom/ContactForm'
import icon1 from '../../images/icons/icon_map_mark_2.svg'
import icon2 from '../../images/icons/icon_calling_2.svg'
import icon3 from '../../images/icons/icon_mail_3.svg'
import icon4 from '../../images/icons/icon_calendar_2.svg'


const ContactSection = (props) => {
    return (
        <section className="contact_section section_space bg-kodo mt-3" style={{backgroundColor: '#EBE5FF'}}>
            <div className="container">
                <div className="contact_info_box row ">
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="iconbox_block text-center">
                            <div className="iconbox_icon">
                                <img src={icon1} alt="Map Mark SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Location</h3>
                                <p className="mb-0">
                                Bushido Towers, Coimbatore
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="iconbox_block text-center">
                            <div className="iconbox_icon">
                                <img src={icon2} alt="Calling SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Contact</h3>
                                 <p className="mb-1">04224768526</p>
                                <p className="mb-1">+91 8925932841</p>
                                {/* <p className="mb-0">+91 6384907747</p> */}
                                {/* <div className="mb-0">+88(0) 555-01117</div> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="iconbox_block text-center">
                            <div className="iconbox_icon">
                                <img src={icon3} alt="User Check SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Email</h3>
                                <p className="mb-0">hello@expertspro.io</p>
                                {/* <p className="mb-0">gmail.@example.com</p> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="iconbox_block text-center">
                            <div className="iconbox_icon">
                                <img src={icon4} alt="Calendar SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Visit Between</h3>
                                <p className="mb-0">Mon to Fri : 9:00AM - 6:00PM</p>
                                {/* <p className="mb-0">Saturday, Sunday: Closed</p> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section_space pb-0 pt-5">
                    <div className="row justify-content-lg-between">
                            <div className="contact_form mb-0 mt-3">
                                <h3 className="details_item_info_title mb-1">Send Us A Message</h3>
                                <p className="mb-3">
                                and our team will call you back within 24 hours. 
                                </p>
                            </div>
                        <div className="col-lg-7">
                                <ContactForm />
                        </div>
                        <div className="col-lg-5">
                            <div className="gmap_canvas">
                                {/* <iframe title='map' src="https://maps.google.com/maps?q=Hanudev%20Info%20Park%20Coimbatore&t=&z=13&ie=UTF8&iwloc=&output=embed"></iframe> */}
                                {/* <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4818.627727542665!2d77.01618591140046!3d11.031782554384751!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85806f7302f11%3A0xf5109c9f8b2303be!2sTIDEL%20Park%20Coimbatore%20Ltd!5e1!3m2!1sen!2sin!4v1757921118892!5m2!1sen!2sin"></iframe> */}
                                <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3916.2528097840145!2d76.99137170765687!3d11.01964918609348!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85834174fe275%3A0x3153223ff51dfe9e!2sBushido%20Towers!5e0!3m2!1sen!2sin!4v1764170248747!5m2!1sen!2sin"></iframe>                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection;